export default __webpack_public_path__ + "static/media/Label_Tutorial.68ad7cd1.svg";